import React from 'react'
import {Icon} from '@chakra-ui/react'

const ReturnsIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.23 3.97523C18.9892 1.49323 15.7684 0 12.2827 0C7.29249 0 2.87332 3.06101 1.06977 7.62455C0.866784 8.13817 1.11861 8.71911 1.63223 8.9221C2.14586 9.12509 2.72679 8.87326 2.92978 8.35964C4.4341 4.55324 8.1202 2 12.2827 2C15.763 2 18.9256 3.78377 20.7504 6.63158H15.5985C15.0462 6.63158 14.5985 7.07929 14.5985 7.63158C14.5985 8.18386 15.0462 8.63158 15.5985 8.63158H22.23C22.7823 8.63158 23.23 8.18386 23.23 7.63158V1C23.23 0.447715 22.7823 0 22.23 0C21.6778 0 21.23 0.447715 21.23 1V3.97523ZM2.99978 19.0172C5.24067 21.4991 8.46135 22.9924 11.9471 22.9924C16.9373 22.9924 21.3564 19.9313 23.16 15.3678C23.363 14.8542 23.1112 14.2733 22.5975 14.0703C22.0839 13.8673 21.503 14.1191 21.3 14.6327C19.7957 18.4391 16.1096 20.9924 11.9471 20.9924C8.46663 20.9924 5.30394 19.2085 3.4792 16.3605H8.63136C9.18364 16.3605 9.63136 15.9128 9.63136 15.3605C9.63136 14.8082 9.18364 14.3605 8.63136 14.3605H1.99978C1.44749 14.3605 0.999779 14.8082 0.999779 15.3605V21.9921C0.999779 22.5444 1.44749 22.9921 1.99978 22.9921C2.55206 22.9921 2.99978 22.5444 2.99978 21.9921V19.0172Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ReturnsIcon
